<template>
  <div>
    <calculator-field :value="form.send" :btn-style="primaryBtnStyle()" label="Você envia" />

    <v-layout wrap style="margin-top: -24px;">
      <v-flex xs12 class="calculation-line">
        <div class="line">{{form.send.currency}} 1 = {{form.receive.currency}} {{rate.toFixed(4)}}</div>
        <div class="dash">&nbsp;</div>
        <div class="circle">&nbsp;</div>
      </v-flex>
      <v-flex xs12 class="calculation-line">
        <div class="line">IOF (1,10%) = {{form.send.currency}} {{iof.toFixed(2)}}</div>
        <div class="dash">&nbsp;</div>
        <div class="circle">&nbsp;</div>
      </v-flex>
      <v-flex xs12 class="calculation-line">
        <div class="line">Taxa administratiava = {{form.send.currency}} {{operation.toFixed(2)}}</div>
        <div class="dash">&nbsp;</div>
        <div class="circle">&nbsp;</div>
      </v-flex>
    </v-layout>

    <calculator-field :value="form.receive" :btn-style="primaryBtnStyle()" label="Beneficiário recebe" />

    <v-layout style="margin-top: -10px;" class="mb-3" v-if="false">
      <v-flex xs12>
        <v-btn
          block
          dark
          class="ma-0"
          :style="secondaryBtnStyle()"
        >
          ENVIAR
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CalculatorField from './CalculatorField'

export default {
  name: 'Calculator',
  components: { 'calculator-field': CalculatorField },
  data () {
    return {
      form: {
        send: { value: 5000, currency: 'BRL' },
        receive: { value: 1261.43, currency: 'USD' }
      },
      firstFieldCurrency: 'BRL',
      secondFieldCurrency: 'USD',
      shouldCalculateConversion: true,
      rate: 1,
      iof: 0,
      operation: 0
    }
  },
  computed: {
    sendCurrency() {
      return this.form.send.currency
    },
    receiveCurrency() {
      return this.form.receive.currency
    },
    receiveValue() {
      return this.form.receive.value
    },
    sendValue() {
      return this.form.send.value
    }
  },
  watch: {
    sendCurrency(new_value, old_value) {
      if (new_value == old_value) return

      if (new_value == this.form.receive.currency) {
        this.disableCalculation()
        this.form.receive.currency = this.nextCurrencyFor(new_value)
      }
      this.$nextTick(function () {
        this.enableCalculation()
        this.calculateConversion('sender')
      })
    },
    receiveCurrency(new_value, old_value) {
      if (new_value == old_value) return

      if (new_value == this.form.send.currency) {
        this.disableCalculation()
        this.form.send.currency = this.nextCurrencyFor(new_value)
      }
      this.$nextTick(function () {
        this.enableCalculation()
        this.calculateConversion('sender')
      })
    },
    sendValue(new_value, old_value) {
      if (new_value == old_value) return

      this.calculateConversion('sender')
    },
    receiveValue(new_value, old_value) {
      if (new_value == old_value) return

      this.calculateConversion('receiver')
    }
  },
  methods: {
    enableCalculation() {
      this.shouldCalculateConversion = true
    },
    disableCalculation() {
      this.shouldCalculateConversion = false
    },
    nextCurrencyFor(currency_to_switch) {
      if (currency_to_switch == 'USD') {
        return 'BRL'
      } else {
        return 'USD'
      }
    },
    getCssProperty(prop_name) {
      return getComputedStyle(document.documentElement, null).getPropertyValue(prop_name)
    },
    primaryBtnStyle() {
      return `height: 56px; background-color: ${this.getCssProperty('--primary-button-background-color')};`
    },
    secondaryBtnStyle() {
      return `height: 56px; background-color: ${this.getCssProperty('--secondary-button-background-color')};`
    },
    calculateConversion(from) {
      if (!this.shouldCalculateConversion) {
        return
      }
      const rates = {
        'USDBRL': 5.2164,
        'EURBRL': 6.3970,
        'EURUSD': 1.2206
      }
      const iof_rate = 0.011
      const operation_rate = 0.01

      let multiply_rate_key = this.form.send.currency + this.form.receive.currency
      let divide_rate_key = this.form.receive.currency + this.form.send.currency
      if (from == 'receiver') {
        multiply_rate_key = this.form.receive.currency + this.form.send.currency
        divide_rate_key = this.form.send.currency + this.form.receive.currency
      }

      if (typeof(rates[multiply_rate_key]) === 'undefined') {
        this.rate = 1 / rates[divide_rate_key]
      } else {
        this.rate = rates[multiply_rate_key]
      }
      let value = this.form.send.value
      if (from == 'receiver') {
        value = this.form.receive.value
      }

      let iof = 0
      let operation = 0
      let value_to_convert = 0

      if (from == 'sender') {
        iof = value * iof_rate
        operation = value * operation_rate
        value_to_convert = (value - iof - operation).toFixed(2)
      } else {
        value_to_convert = (value / (1 - (iof_rate + operation_rate))).toFixed(2)
      }

      this.iof = iof
      this.operation = operation

      if (from == 'receiver') {
        this.form.send.value = (value_to_convert * this.rate).toFixed(2)
      } else {
        this.disableCalculation()
        this.form.receive.value = (value_to_convert * this.rate).toFixed(2)
        this.$nextTick(function () {
          this.enableCalculation()
        })
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.calculateConversion('sender')
    })
  }
}
</script>

<style>
  .field-height { height: 62px; }
  .calculation-line { position: relative; height: 40px; padding-top: 12px; }
  .calculation-line .line { padding-left: 40px; }
  .calculation-line .dash { position: absolute; left: 16px; top: -4px; width: 2px; height: 48px; background-color: var(--primary-button-background-darker-color); }
  .calculation-line .circle { position: absolute; left: 7px; top: 12px; width: 20px; height: 20px; background-color: var(--primary-button-background-darker-color); border-radius: 20px; }
  .currency-flag { width: 30px; height: 20px; border-radius: 2px; }
</style>



// WEBPACK FOOTER //
// src/Calculator.vue